import { Injectable } from '@angular/core';
import { Project, ProjectFeed, ProjectFeedLog, ProjectFeedParseResult } from '../models/project';
import { environment } from '../../environments/environment';
import { Client } from '../models/client';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

@Injectable()
export class ProjectFeedService {
  constructor(private http: HttpClient) {

  }

  createOrUpdate(project: Project, feed: ProjectFeed): Observable<ProjectFeed> {
    let body = JSON.stringify(feed.toJson());

    return this.http.post(`${environment.apiUrl}/projects/${project.id}/feed`, body)
      .pipe(map(json => new ProjectFeed(json)));
  }

  deleteFeed(project: Project): Observable<Object> {
    return this.http.delete(`${environment.apiUrl}/projects/${project.id}/feed`);
  }

  parseFeed(project: Project, feed: ProjectFeed): Observable<ProjectFeedParseResult> {
    return this.http.get(`${environment.apiUrl}/projects/${project.id}/feed/parse`)
      .pipe(map(json => new ProjectFeedParseResult(json)))
  }

  parseRawFeed(client: Client, url: string, configuration: string): Observable<ProjectFeedParseResult> {
    let params = new HttpParams();
    params = params.set('url', url);
    params = params.set('configuration', configuration);

    return this.http.get<any>(`${client.url}/feed/parse`, { params: params })
      .pipe(map(json => new ProjectFeedParseResult(json)));
  }

  getLog(project: Project): Observable<ProjectFeedLog[]> {
    return this.http.get<any>(`${project.url}/feed/log`)
      .pipe(map(json => {
        return json.data.map(j => {
          return ProjectFeedLog.fromJson(j);
        })
      }));
  }

  loadRaw(project: Project): Observable<string> {
    return this.http.get<any>(`${project.url}/feed/raw`)
      .pipe(map(data => {
        return data.contents;
      }));
  }

  sync(project: Project) {
    return this.http.post<any>(`${project.url}/sync`, {})
      .pipe(map(data => {
        return;
      }));
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/project-feed.service.ts